import { useState } from "react";
// import { SpeedDial } from 'primereact/speeddial';
import { Card } from "primereact/card";
import { Link } from "react-router-dom";
// import { useHistory } from 'react-router-dom';

import styles from "./styles.module.scss";
import { Button } from "primereact/button";

export const CardMenu = () => {
  const [isTabela, setIsTabela] = useState(false);

  const [menu] = useState([
    { title: "Certidões de Crédito", subTitle: "Consulta as Obrigações.", imageUrl: "./images/02.png", pathUrl: "/certidoesAtivas" },
    { title: "Crédito Salarial", subTitle: "Consulta as Obrigações.", imageUrl: "./images/02.png", pathUrl: "/manterObrigacao" },
    // { title: 'Quitação', subTitle: 'Consulta as Certidões Emitidas', imageUrl: './images/03.png', pathUrl: '/certidoesAtivas' },
    // { title: 'C.D.F', subTitle: 'Compensação de Débitos Fiscais.', imageUrl: './images/04.png', pathUrl: '/certidoesAtivas' },
    { title: "Tabelas", subTitle: "Cadastros Básicos .", imageUrl: "./images/01.png", pathUrl: "#" },
  ]);

  return (
    <div className={styles.container}>
      {!isTabela &&
        menu.map((item, key) => {
          return (
            <Link key={key} to={item.pathUrl} onClick={() => (item.title === "Tabelas" ? setIsTabela(true) : setIsTabela(false))}>
              <Card
                className={styles.card_container}
                title={item.title}
              // subTitle={item.subTitle}
              >
                <div className={styles.image_icon}>
                  <img src={item.imageUrl} alt={item.imgDesc} />
                </div>
              </Card>
            </Link>
          );
        })}

      {isTabela && (
        <>
          {/* <Button
            icon="pi pi-arrow-left"
            label=" Voltar"
            className=" p-button-text"
            onClick={() => setIsTabela(false)}
            style={{ fontWeight: 500 }}
          /> */}
          <Link to="/manterAmparoLegal">
            <Card className={styles.card_container} title="Amparo Legal" />
          </Link>

          <Link to="/manterTipoCertidao">
            <Card className={styles.card_container} title="Tipos de Certidão de Crédito" />
          </Link>

          <Link to="/manterEmpresa">
            <Card className={styles.card_container} title="Pessoa Jurídica" />
          </Link>

          {/* <Link to="/cadastroTipoAto">
            <Card className={styles.card_container} title="Tipo Ato" />
          </Link> */}
        </>
      )}
    </div>
  );
};
